
<agpr-panel header="UMT.activityLog.activityInformation">
    <div class="agpr-activityLog-flexRow">
        <div class="agpr-activityLog-flexItem-informationKey">{{ "UMT.activityLog.lastLoginDate" | localize }}:</div>
        <div class="agpr-activityLog-flexItem">{{ loginStats.lastLoginDate | changeTimeZone: preferences.timeZone: 'MMMM DD, YYYY h:mm z' }}</div>
    </div>
    <div class="agpr-activityLog-flexRow">
        <div class="agpr-activityLog-flexItem-informationKey">{{ "UMT.activityLog.logins" | localize }}:</div>
        <div class="agpr-activityLog-flexItem">{{ loginStats.recentLoginCount }}</div>
    </div>
</agpr-panel>
<agpr-panel header="UMT.activityLog.activityLogs">
    <agpr-filter-dropdown
        [id]="'agpr_activityLog_filterDropdown'"
        [showQuickFilter]="true"
        [showSelectedFilters]="true"
        quickFilterPlaceholder="UMT.activityLog.filterDropdown.placeholder"
        ariaLabel="UMT.activityLog.filterDropdown.placeholder"
    ></agpr-filter-dropdown>
    <ul class="agpr-activityLog-list">
        @for(item of filteredActivities; track item){
            <li class="agpr-activityLog-listItem">
                @let actionLabel = (item.specificAction || ('UMT.activityLog.activityType.' + item.action | localize)) | uppercase;
                <div class="agpr-activityLog-listItem-header">
                    <div
                        class="agpr-activityLog-listItem-action"
                        [ariaLabel]="actionLabel"
                        [agprTooltip]="actionLabel"
                        tooltipPosition="right"
                    >
                        {{ actionLabel }}
                    </div>
                    <div class="agpr-activityLog-listItem-date">
                        {{ item.date | changeTimeZone: preferences.timeZone: preferences.getDateFormatString(true, true, true)}}
                    </div>
                </div>
                @if(item.action === activityTypeEnum.LOGIN || item.action === activityTypeEnum.LOGIN_ERROR) {
                    <div
                        class="agpr-activityLog-icon agpr-activityLog-toggleButton"
                        [class]="item.isExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
                        [ariaLabel]="item.isExpanded ? 'Expanded' : 'Collapsed'"
                        tabindex="0"
                        (click)="item.isExpanded = !item.isExpanded"
                    ></div>
                }@else {
                    <div
                        class="agpr-activityLog-icon fa-regular fa-circle-info"
                        [ariaLabel]="item.details"
                        [agprTooltip]="item.details"
                        tooltipPosition="left"
                    ></div>
                }
                @if(item.action === activityTypeEnum.LOGIN || item.action === activityTypeEnum.LOGIN_ERROR) {
                    <div
                        class="agpr-activityLog-listItem-details"
                        [@showMoreContent]="item.isExpanded ? 'expanded' : 'collapsed'"
                    >
                        @for(itm of item.detailsObj | keyvalue: compareFn; track itm){
                            <div class="agpr-activityLog-cardGrid">
                                <div class="agpr-activityLog-flexItem-cardKey">
                                    {{'UMT.activityLog.' + itm.key | localize}}:
                                </div>
                                <div class="agpr-activityLog-flexItem">
                                    @if (itm.key === 'userIP' || itm.key === 'username') {
                                        {{ itm.value }}
                                    } @else {
                                        {{ 'UMT.activityLog.' + itm.key + '.' + itm.value | localize }}
                                    }
                                </div>
                            </div>
                        }
                    </div>
                }
            </li>
        }
    </ul>
    @if(filteredActivities.length === 0) {
        <agpr-message
            [severity]="messageSeverity.noContent"
            [useWhiteBg]="true"
        >
            <span> {{ 'UMT.profile.RHP.activity.noContent' | localize }} </span>
        </agpr-message>
    }
</agpr-panel>
